import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ChevronDoubleUpIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M10 3.65723C9.67771 3.65723 9.35552 3.75051 9.07552 3.93717L3.11686 7.90853C2.73103 8.16603 2.5 8.59917 2.5 9.0625C2.5 10.17 3.73491 10.8306 4.65658 10.2165L10 6.65365L15.3434 10.2165C16.2651 10.8306 17.5 10.17 17.5 9.0625C17.5 8.59833 17.2681 8.16603 16.8831 7.90853L10.9245 3.93717C10.6445 3.75051 10.3223 3.65723 10 3.65723ZM10 8.93392C9.67771 8.93392 9.35552 9.0272 9.07552 9.21387L3.11686 13.1852C2.73103 13.4427 2.5 13.8759 2.5 14.3392C2.5 15.4467 3.73491 16.1073 4.65658 15.4932L10 11.9303L15.3434 15.4948C16.2651 16.109 17.5 15.4467 17.5 14.3392C17.5 13.875 17.2681 13.4427 16.8831 13.1852L10.9245 9.21387C10.6445 9.0272 10.3223 8.93392 10 8.93392Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ChevronDoubleUpIcon.propTypes = {
  sx: PropTypes.object,
};

export default ChevronDoubleUpIcon;
